import { Logger, engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";

/**
 * Style holds basic properties for all kind of styles.
 * @class Style
 */
@engineComponent(ComponentTypes.Style)
export class Style {
    name: string;

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        if (this.name == null) {
            this.name = node.nodeName;
        }
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    protected log(s: string): void {
        if (DEBUG) {
            var compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/Style.ts
 **/